module.exports = __webpack_public_path__ + "img/5_004.498198bd.webp";